import classnames from "classnames";
import React, { useState, useRef } from "react";
import ReactPlayer from "react-player";
import "next-cloudinary/dist/cld-video-player.css";

const DuncanTaylorVideo = (props: any) => {
  const { data, classforvideo }: any = props;
  const ref = useRef<ReactPlayer>(null);
  const [sound, setSound] = useState(false);

  const handleToggleMute = () => setSound((prev) => !prev);

  return (
    <div className={classforvideo}>
      <video
        controls
        width="100%"
        height="100%"
        muted={!sound}
        autoPlay
        playsInline
        webkit-playsinline="true"
        loop
        // style={{
        //   height: "600px",
        // }}
        // className={classforvideo}
      >
        <source src={props?.data} type="video/mp4" />
        Sorry, your browser doesn't support embedded videos.
      </video>

      {/* Optional sound toggle button */}
      {/* <div
        className={classnames(
          "sound-toggle",
          sound ? "sound-on" : "sound-off"
        )}
        onClick={handleToggleMute}
      >
        {sound ? "Sound On" : "Sound Off"}
      </div> */}
    </div>
  );
};

export default DuncanTaylorVideo;
